const getFontWeightFromProps = props => {
  if (props.bold) return "bold"
  if (props.black) return 900
  if (props.light) return 200
  return
}
const getFontStyleFromProps = props => {
  if (props.italic) return "italic"
  return
}

export {getFontWeightFromProps, getFontStyleFromProps}
